import { CredentialsKeyEnum } from '../provider.enum';
export const secureCredentials = [
    CredentialsKeyEnum.ApiKey,
    CredentialsKeyEnum.ApiToken,
    CredentialsKeyEnum.SecretKey,
    CredentialsKeyEnum.Token,
    CredentialsKeyEnum.Password,
    CredentialsKeyEnum.ServiceAccount,
];
